<div class="min-h-screen flex flex-col error-screen-background bg-ignyte-page">

  <!-- Header -->
  <header class="relative z-20 w-full px-4 sm:px-6 pt-4">
    <div class="flex flex-nowrap items-center justify-between gap-2 sm:gap-3">
      <img src="assets/shared/images/images/ignytebyyrefy-logo.svg" alt="ignyte logo" class="h-6 sm:h-10 shrink-0" />

      <span
        class="inline-flex items-center gap-0.5 sm:gap-1 text-[10px] sm:text-sm font-medium text-gray-500 justify-end whitespace-nowrap leading-none">
        Need Assistance?
        <lib-icon [svg]="'question-circle'" [category]="AssetsCategory.Header" iconClass="w-2.5 h-2.5 sm:w-4 sm:h-4">
        </lib-icon>

        <lib-button
          customClass="inline-flex items-center p-0 border-0 bg-transparent shadow-none font-semibold text-blue-950 cursor-pointer hover:underline active:underline"
          [ariaLabel]="supportLabel" (buttonClick)="contactSupport()">
          {{ supportLabel }}
        </lib-button>
      </span>
    </div>
  </header>

  <!-- Center Content -->
  <div class="relative z-10 flex-1 flex items-center justify-center px-6 pt-6 sm:pt-8">
    <div class="w-full max-w-2xl rounded-2xl bg-white border border-neutral-200 shadow-lg">

      <div class="flex w-full justify-center overflow-hidden px-2 sm:px-0 -mt-4">
        <lib-icon [icon]="illustrationSvg" [category]="AssetsCategory.Button" class="flex items-center justify-center"
          iconClass="w-45 h-45 sm:w-40 sm:h-40 md:w-56 md:h-56 lg:w-64 lg:h-64"
          svgClass="w-45 h-45 sm:w-40 sm:h-40 md:w-56 md:h-56 lg:w-64 lg:h-64"></lib-icon>
      </div>

      <h1 class="-mt-4 sm:-mt-10 text-center text-2xl sm:text-3xl font-semibold">
        {{ heading }}
      </h1>

      <p class="mt-3 px-4 sm:px-8 text-center text-sm sm:text-base md:text-lg text-neutral-600">
        {{ subtext }}
      </p>

      <div class="mt-4 mb-4 flex justify-center">
        <lib-button [buttons]="backButtonConfigs" (buttonClick)="goBack()">
        </lib-button>
      </div>

    </div>
  </div>

</div>